/* Templates: library cards, the install plan, save-as-template and updates. */

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--osp-space-3);
}

.filters > * {
  flex: 1 1 200px;
  max-width: 320px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 280px), 1fr));
  gap: var(--osp-space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  height: 100%;
  padding: var(--osp-space-4) var(--osp-space-5);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
  background: var(--osp-surface);
}

.card:hover,
.card:focus-within {
  border-color: var(--osp-border-strong);
}

.cardHead {
  display: flex;
  align-items: flex-start;
  gap: var(--osp-space-3);
}

.cardTitle {
  font-weight: 620;
  color: var(--osp-ink);
  text-decoration: none;
  overflow-wrap: anywhere;
}

.cardTitle:hover {
  color: var(--osp-accent-ink);
  text-decoration: underline;
}

.cardDesc {
  margin: 0;
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--osp-space-1) var(--osp-space-2);
  margin-top: auto;
  font-size: var(--osp-text-xs);
  color: var(--osp-ink-muted);
}

.mark {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--osp-radius);
  background: var(--osp-accent-soft);
  color: var(--osp-accent-ink);
}

.markLarge {
  width: 44px;
  height: 44px;
}

.readme {
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.readme > :first-child {
  margin-top: 0;
}

.readme h3,
.readme h4,
.readme h5,
.readme h6 {
  margin: var(--osp-space-4) 0 var(--osp-space-2);
  font-weight: 620;
}

.readme p,
.readme ul,
.readme ol,
.readme blockquote,
.readme pre {
  margin: 0 0 var(--osp-space-3);
}

.readme blockquote {
  padding-inline-start: var(--osp-space-3);
  border-inline-start: 3px solid var(--osp-border-strong);
  color: var(--osp-ink-muted);
}

.readme pre {
  padding: var(--osp-space-3);
  border-radius: var(--osp-radius);
  background: var(--osp-surface-sunken);
  overflow-x: auto;
}

.readme code {
  font-family: var(--osp-font-mono);
  font-size: 0.92em;
}

.readme a {
  color: var(--osp-accent-ink);
}

.contents {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 220px), 1fr));
  gap: var(--osp-space-3) var(--osp-space-5);
  margin: 0;
}

.contents dt {
  font-weight: 600;
}

.contents dd {
  margin: 2px 0 0;
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
  overflow-wrap: anywhere;
}

.versions {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.versionRow {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: var(--osp-space-3);
  border-bottom: 1px solid var(--osp-border);
}

.versionRow:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.versionHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--osp-space-2);
}

.steps {
  display: flex;
  flex-wrap: wrap;
  gap: var(--osp-space-2) var(--osp-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--osp-text-sm);
  color: var(--osp-ink-muted);
}

.steps li[aria-current="step"] {
  color: var(--osp-accent-ink);
  font-weight: 620;
}

.planGroup {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
}

.planList {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.planItem {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--osp-space-1) var(--osp-space-2);
}

.kind {
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
}

.clash {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-3);
  padding: var(--osp-space-4);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
  background: var(--osp-surface);
}

.choices {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  margin: 0;
  padding: 0;
  border: 0;
}

.choices legend {
  margin-bottom: var(--osp-space-2);
  font-weight: 600;
  font-size: var(--osp-text-sm);
}

.choice {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: 2px var(--osp-space-2);
  cursor: pointer;
}

.choice input {
  margin-top: 3px;
  accent-color: var(--osp-accent);
}

.choiceText {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.choiceTitle {
  font-weight: 560;
}

.choiceHint {
  color: var(--osp-ink-muted);
  font-size: var(--osp-text-sm);
}

.renameKey {
  max-width: 340px;
  margin: var(--osp-space-2) 0 var(--osp-space-1);
  padding-inline-start: calc(var(--osp-space-2) + 16px);
}

.sides {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: var(--osp-space-3);
}

.side {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  min-width: 0;
  padding: var(--osp-space-3);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
}

.side h4 {
  margin: 0;
  font-size: var(--osp-text-sm);
  font-weight: 620;
}

.recordPick {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-2);
  padding: var(--osp-space-3) var(--osp-space-4);
  border: 1px solid var(--osp-border);
  border-radius: var(--osp-radius);
}

.recordPick legend {
  padding: 0 var(--osp-space-1);
  font-weight: 600;
}

.recordList {
  display: flex;
  flex-direction: column;
  gap: var(--osp-space-1);
  max-height: 260px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.progress {
  display: flex;
  align-items: center;
  gap: var(--osp-space-2);
}

.installedRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--osp-space-2) var(--osp-space-4);
  padding: var(--osp-space-4) var(--osp-space-5);
}

.installedMain {
  display: flex;
  flex: 1 1 280px;
  flex-direction: column;
  gap: var(--osp-space-1);
  min-width: 0;
}
